// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import wixWindow from 'wix-window';

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function text25_click(event) {
	let $item = $w.at(event.context);
    let data = $item("#dataset1").getCurrentItem();
	const validTitle = data.title && data.title !== '';
	const validDescription = data.description && data.description !== '';
	const validImage = data.image && data.image !== '';
	if (!(validTitle && validDescription && validImage)) {
		return;
	} 
	wixWindow.openLightbox("Beer Description", {"data": data});
}